import { Row, Table } from "antd";
import { Header } from "./components/Header";
import { useFetchCount } from "./hooks/useFetchCount";
import { useFetchData } from "./hooks/useFetchData";
import { useTableColumns } from "./hooks/useTableColumns";
import { TablePagination } from "../../components/TablePagination";
import { useCallback, useState } from "react";
import { useSortOrder } from "./hooks/useSortOrder";
import { ITask } from "./types";
import { createPortal } from "react-dom";
import { useOpenSidebar } from "./hooks/useOpenSideBar";
import { CloseModal } from "./components/CloseModal";
import "./styles.scss";

export const Tasks = () => {
  const [selectedItem, setSelectedItem] = useState<ITask | undefined>(undefined);

  const [taskIdToClose, setTaskIdToClose] = useState<string | undefined>(undefined);

  const { total, isLoading: isCountLoading, request, setRequest, onPageChange, fetchCount } = useFetchCount();

  const { data, isLoading, setData, fetchData } = useFetchData(request);

  const reload = useCallback(() => {
    fetchCount(true);
    fetchData(true);
  }, [fetchCount, fetchData]);

  const { sidebar } = useOpenSidebar(request.isClosed, selectedItem, setSelectedItem, setTaskIdToClose, reload);

  const onRow = useCallback(
    (record: any) => ({
      onClick: () => setSelectedItem(record)
    }),
    []
  );

  const { columns } = useTableColumns(request.isClosed, setTaskIdToClose, reload);

  const { onSorterChange } = useSortOrder(request, setRequest);

  return (
    <Row className="table-page-content">
      <Header setRequest={setRequest} setData={setData} />
      <Row className="d-block table__container w-100 mx-8 mt-4">
        <Table
          dataSource={data}
          columns={columns}
          loading={isLoading}
          pagination={false}
          className="overflow-y-auto clickable-rows-table tasks-table"
          rowKey="id"
          onChange={onSorterChange}
          onRow={onRow}
        />
        <TablePagination
          isTotalLoading={isCountLoading}
          total={total}
          currentPage={request.pageNumber}
          pageSize={request.pageSize}
          onPageChange={onPageChange}
        />
      </Row>

      <CloseModal taskId={taskIdToClose} setTaskId={setTaskIdToClose} reload={reload} />

      {selectedItem && createPortal(sidebar, document.body)}
    </Row>
  );
};
